import { DocumentRow } from "../models/integration.model";

export const documents: DocumentRow[] = [
    {
      id: 1,
      title:
        'Service Agreement signed by the client and stamped by the company',
      isRequired: true,
      key: 'sla_file',
    },
    {
      id: 2,
      title: 'Deed of Establishment and Amendment',
      isRequired: true,
      key: 'amandement_business_file',
    },
    {
      id: 3,
      title: 'Business/Personal NPWP',
      isRequired: false,
      key: 'npwp_file',
    },
    {
      id: 4,
      title: 'Business Identification Number (NIB)',
      isRequired: false,
      subtitle: '(for Business Entity)',
      key: 'nib_file',
    },
    {
      id: 5,
      title:
        'Business Entity Bank Account Number / Copy of Bank Account Statement',
      isRequired: true,
      key: 'bank_account_number_file',
    },
    {
      id: 6,
      title:
        'ID card (KTP) of the Director / Representative in charge of signing',
      isRequired: true,
      key: 'id_card_file',
    },
    {
      id: 7,
      title: 'Power of Attorney',
      isRequired: false,
      subtitle: '(for Directors unable to sign)',
      key: 'power_of_attorney_file',
    },
    {
      id: 8,
      title: 'Statement Letter for Non-Business Entity Bank Accounts',
      isRequired: false,
      key: 'statement_letter_file',
    },
    {
      id: 9,
      title: 'ID card (KTP) of the PIC for the Dashboard / API account',
      isRequired: false,
      key: 'pic_dashboard',
    },
  ];
